// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const ApprovalKreditService = {};

ApprovalKreditService.getApkLoanRequestForCreditApproval = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  return lossClient({
    url:
      `/ApkLoan/ApkLoanRequestForCreditApproval?pageSize=` +
      data.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&applicationid=" +
      data?.applicationid +
      "&name=" +
      data?.name +
      "&endApplicationDate=" +
      data?.endApplicationDate +
      "&startApplicationDate=" +
      data?.startApplicationDate,
    method: "get",
    headers: {},
  });
};
 

export default ApprovalKreditService;
